<template>
  <div class="container">
    <div class="page-title">
      <h2 class="title__h2">Servicios</h2>
    </div>
    <section class="services-container">
      <div class="services-item" :key="item" v-for="item in services">
        <div class="services-icon">
          <i :class="item.icon" aria-hidden="true"></i>
        </div>
        <h3>{{ item.title }}</h3>
        <p class="text__paragraph text__paragraph--padding">
          {{ item.description }}
        </p>
        <router-link :to="{ name: 'Contacto' }" class="read-more"
          >Saber Más</router-link
        >
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ServicesView",
  data() {
    return {
      services: [
        {
          icon: "fas fa-credit-card",
          title: "E-commerce",
          description:
            "Utilizando un CMS que facilitará tu gestión del E-Commerce desarrollaré tu tienda virtual con el diseño que deseas. Contando con el carro de compras, categorías y demás.",
        },
        {
          icon: "fas fa-columns",
          title: "Maquetación Web",
          description:
            "Realizo tu diseño web en HTML. Creo la estructura del diseño de tu preferencia en HTML utilizando las etiquetas correspondientes en cada sección y el uso de estilos en CSS.",
        },
        {
          icon: "fas fa-code",
          title: "Programación Web",
          description:
            "Desarrollo la programación fullstack de tu web. Utilizando lenguajes como PHP o frameworks como Laravel/VueJs, ofreciendote la aplicación que necesitas totalmente personalizada",
        },
        {
          icon: "fas fa-paste",
          title: "PSD to HTML",
          description:
            "¿Tienes un diseño en photoshop y no sabes cómo plasmarlo?. Pasaré tu diseño o idea a HTML con sus respectivos colores, estilos y todos esos detalles que consideres o desees.",
        },
        {
          icon: "fab fa-elementor",
          title: "Wordpress Elementor",
          description:
            "¿Quieres crear una página en wordpress con Elementor?. Haré tu diseño en elementor con las secciones correspondientes, menús personalizados y plantillas.",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style>
</style>